import React from 'react';
export type Faq = {
  question: string;
  answer: string;
};
export function FaqList({
  faqs,
  heading = 'Frequently asked questions'
}: {
  faqs: Faq[];
  heading?: string;
}) {
  return <section className="w-full bg-white py-14 lg:py-20" data-id="element-166" data-mp="263gztf45mei7">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-167" data-mp="261w61rpnyzle">
        <h2 className="font-display text-[24px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[30px]" data-id="element-168" data-mp="215feenj9a33k">
          {heading}
        </h2>
        <dl className="mt-8 border-t border-black/10" data-id="element-169" data-mp="1x4vkdstzbfln">
          {faqs.map(faq => <div key={faq.question} className="border-b border-black/10 py-6" data-id="element-170" data-mp="1sa971k4c7cyx">
              <dt className="font-display text-[17px] font-bold leading-snug tracking-tight text-ink" data-id="element-171" data-mp="1ndr4mqwhbqpr">
                {faq.question}
              </dt>
              <dd className="mt-2 max-w-[720px] text-[15px] leading-relaxed text-steel/75" data-id="element-172" data-mp="1detjlxy9ifbi">
                {faq.answer}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}